import styled from 'styled-components';

export const Header = styled.div`
	padding: 16px 24px;
	background: white;
`;

Header.Title = styled.span`
	font-weight: 500;
	font-size: 24px;
	line-height: 29px;
	color: #00417A;
`;
